export default "__VITE_ASSET__D5IY0J$P__"